module.exports = __webpack_public_path__ + "img/web_step_03.8364bb2b.png";